import React from "react";
import { Select } from "antd";
import operators from "../operators.json";

interface Operator {
  operator: string;
  operatorType: string;
  operatorArityType: string;
  resultDataType: string;
}

interface OperatorGroup {
  operators: Operator[];
}

interface Operators {
  [key: string]: OperatorGroup;
}

const typedOperators = operators as Operators;

interface OperatorSelectProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
  dataType?: string;
}

const { Option } = Select;

export const OperatorSelect: React.FC<OperatorSelectProps> = ({ 
  value, 
  onChange, 
  className,
  dataType = "Character String"
}) => {
  const getOperatorKey = (type: string): string => {
    const mapping: { [key: string]: string } = {
      "Logical Truth": "logicalTruth",
      "Binary Bit": "binaryBit", 
      "Integer Number": "integerNumber",
      "Floating Point Number": "floatingPointNumber",
      "Character String": "characterString",
      "Text Object": "textObject",
      "Instance Object": "instanceObject",
      "Interval Object": "intervalObject",
      "Geometry Object": "geometryObject",
      "Geography Object": "geographyObject",
      "Binary Structured": "binaryStructured",
      "Binary Unstructured": "binaryUnstructured"
    };
    return mapping[type] || "";
  };

  const availableOperators = typedOperators[getOperatorKey(dataType)]?.operators || [];  
  console.log("availableOperators",availableOperators);

  return (
    <Select
      value={value}
      onChange={onChange}
      className={className}
      showSearch
      style={{width: '250px'}}
      optionFilterProp="children"
      placeholder="Select an operator"
    >
      {availableOperators.map((op: Operator) => {
        if (op.operatorType === "Comparison Operator" || op.operatorType === "Set Comparison Operator" || op.operatorType === "Range Comparison Operator") {
          return (
            <Option key={op.operator + " " + op.resultDataType} value={op.operator}>
              {`${op.operator} : ${op.operatorArityType} : ${op.resultDataType}`}
            </Option>
          );
        }
        return null;
      })}
    </Select>
  );
}; 